const mergeRefs = function () {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return node => {
    for (const ref of refs) {
      if (ref) {
        ref.current = node;
      }
    }
  };
};
export default mergeRefs;